export function useHelpers() {
  const { $versions } = useNuxtApp();

  function roundNumber(number: number | null, numberOfDigits = 2): number | null {
    if (number === null) {
      return null;
    }

    return Number(number.toFixed(numberOfDigits));
  }

  const gatewayType = computed(() => {
    switch ($versions?.value.paymentForm) {
      case '2':
        return 'braintree';
      case '3':
        return 'paddle';
      case '4':
        return 'stripe_us';
      case '1':
      default:
        return 'stripe_pearl';
    }
  });

  return {
    roundNumber,
    gatewayType,
  };
}
